import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgLeftCircle({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.376 11H16a1 1 0 110 2h-5.624l2.325 2.287a1 1 0 01-1.402 1.426l-4.066-3.998a1 1 0 01-.002-1.428l.002-.002L11.3 7.287A1 1 0 0112.7 8.713L10.376 11zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16z"
        fill={color}
      />
    </svg>
  )
}

export default SvgLeftCircle
